import React from "react";
import { StyledToggleButtonLeft, StyledToggleButtonRight } from "./setup.style";

const ToggleButton = ({ setOn, isOn }) => {
    return (
        <div>
            <StyledToggleButtonLeft onClick={() => setOn(true)} value={isOn} type="button">
                On
            </StyledToggleButtonLeft>
            <StyledToggleButtonRight onClick={() => setOn(false)} value={!isOn} type="button">
                Off
            </StyledToggleButtonRight>
        </div>
    );
};
export default React.memo(ToggleButton);